import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'qumra-loading',
  styleUrl: 'qumra-loading.css',
  shadow: true,
})

export class QumraLoading {
  @Prop() loading: boolean = false;
  @Prop() loadingSize: string = "40px";
  @Prop() color:  string = "";;
  @Prop() borderType:  string = "solid";;

  render() {
    return (
      <div class="flex">
        {this.loading && (
          <div class="flex items-center justify-center min-h-screen">
            <span class="h-max w-max animate-bounce">
              <div
                class=" loading-main border-t-transparent"
                style={{   width: this.loadingSize, height: this.loadingSize ,
                  borderStyle:this.borderType,
                  borderColor: this.color,
                  borderTopColor: "transparent"
                }}
              ></div>
            </span>
          </div>
        )}
      </div>
    );
  }
}
